import { FormControlProps } from '@material-ui/core';

export const formControlProp: FormControlProps = {
    variant: 'outlined',
    style: { width: '100%' },
    size: 'small',
} as const;

export const inputsStyle = { backgroundColor: 'white' } as const;
